import {isNil, isFunction} from "lodash-es";
import IConnection_TokenUI from "../models/IConnection_TokenUI";
import INavItem from "../models/INavItem";
import IUserTypeAccessDetail from "../models/IUserTypeAccessDetail";
import UserTypesEnum from "../models/UserTypesEnum";
import IConnection_Token from "../models/IConnection_Token";

const ADMIN_ONLY: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SALES: {
        VIEW: false,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const ALL_ACCESS: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SHIP_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: true,
        EDIT: true,
    },
    DRIVER: {
        VIEW: true,
        EDIT: true,
    },
};

const Orders: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: true,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: true,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const OrderEntry: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Quotes: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Templates: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Clients: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Shipments: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SHIP_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: true,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: true,
    },
    VENDOR_SOURCE_USER: {
        VIEW: true,
        EDIT: false,
    },
    DRIVER: {
        VIEW: true,
        EDIT: true,
    },
};

const Reports: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: true,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SALES: {
        VIEW: false,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const BusinessProfile: IUserTypeAccessDetail = ADMIN_ONLY;

const BusinessIntegrations = BusinessProfile;

const BusinessSettings = BusinessProfile;

const Users: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const UsersVendors: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SALES: {
        VIEW: true,
        EDIT: true,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const UsersVendorsUsers: IUserTypeAccessDetail = ADMIN_ONLY;

const Catalogs: IUserTypeAccessDetail = ADMIN_ONLY;

const Inventory: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: false,
        EDIT: false,
    },
    ORDER_MGMT: {
        VIEW: true,
        EDIT: false,
    },
    SALES: {
        VIEW: true,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: true,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Caches: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: false,
    },
    ORDER_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SALES: {
        VIEW: true,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const PurchaseOrders: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    SHIP_MGMT: {
        VIEW: true,
        EDIT: true,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SALES: {
        VIEW: false,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: true,
        EDIT: true,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Accounting: IUserTypeAccessDetail = {
    ADMIN: {
        VIEW: true,
        EDIT: true,
    },
    INVENTORY_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SHIP_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    MANAGEMENT: {
        VIEW: true,
        EDIT: true,
    },
    ORDER_MGMT: {
        VIEW: false,
        EDIT: false,
    },
    SALES: {
        VIEW: false,
        EDIT: false,
    },
    SUPPORT: {
        VIEW: false,
        EDIT: false,
    },
    VENDOR_SOURCE_USER: {
        VIEW: false,
        EDIT: false,
    },
    DRIVER: {
        VIEW: false,
        EDIT: false,
    },
};

const Sync = Caches;

const Dashboard: IUserTypeAccessDetail = ALL_ACCESS;

const Materials = ADMIN_ONLY;
const Sources = ADMIN_ONLY;
const Forecasts = ALL_ACCESS;
const Projects = ALL_ACCESS;

const hasAccess = (
    navItem: INavItem,
    isSupplierUser: boolean,
    supplierUserToken?: IConnection_TokenUI,
    vendorUserToken?: IConnection_Token,
    isVendorSourceUser?: boolean
) => {
    let userHasAccess = false;

    if (isSupplierUser) {
        if (supplierUserToken) {
            switch (supplierUserToken.User_Type?.id) {
                case UserTypesEnum.ADMIN:
                    userHasAccess = navItem.viewAccessDetail.ADMIN.VIEW;
                    break;

                case UserTypesEnum.MANAGEMENT:
                    userHasAccess = navItem.viewAccessDetail.MANAGEMENT.VIEW;
                    break;

                case UserTypesEnum.SALES:
                    userHasAccess = navItem.viewAccessDetail.SALES.VIEW;
                    break;

                case UserTypesEnum.SUPPORT:
                    userHasAccess = navItem.viewAccessDetail.SUPPORT.VIEW;
                    break;

                case UserTypesEnum.INVENTORY_MGMT:
                    userHasAccess = navItem.viewAccessDetail.INVENTORY_MGMT.VIEW;
                    break;

                case UserTypesEnum.ORDER_MGMT:
                    userHasAccess = navItem.viewAccessDetail.ORDER_MGMT.VIEW;
                    break;

                case UserTypesEnum.SHIP_MGMT:
                    userHasAccess = navItem.viewAccessDetail.SHIP_MGMT.VIEW;
                    break;

                case UserTypesEnum.DRIVER:
                    userHasAccess = navItem.viewAccessDetail.DRIVER.VIEW;
                    break;
            }
        }
    } else {
        if (vendorUserToken) {
            switch (vendorUserToken.User_Type?.id) {
                case UserTypesEnum.ADMIN:
                    userHasAccess = navItem.viewAccessDetail.ADMIN.VIEW;
                    break;

                case UserTypesEnum.MANAGEMENT:
                case UserTypesEnum.SALES:
                case UserTypesEnum.SUPPORT:
                    userHasAccess = navItem.viewAccessDetail.SALES.VIEW;
                    break;
            }
        }
    }

    if (isVendorSourceUser) {
        userHasAccess = navItem.viewAccessDetail.VENDOR_SOURCE_USER.VIEW;
    }

    if (!isNil(navItem.viewAccessDetailFn) && isFunction(navItem.viewAccessDetailFn)) {
        const viewAccessDetailFnData = navItem.viewAccessDetailFn();

        if (viewAccessDetailFnData.useOverride) {
            userHasAccess = viewAccessDetailFnData.userHasAccess;
        }

        // console.log("viewAccessDetailFn", viewAccessDetailFnData);
    }

    return userHasAccess;
};

const ViewAccessService = {
    Orders,
    OrderEntry,
    Quotes,
    Templates,
    Clients,
    Shipments,
    Reports,
    BusinessProfile,
    BusinessIntegrations,
    BusinessSettings,
    Users,
    UsersVendors,
    UsersVendorsUsers,
    Catalogs,
    Inventory,
    Caches,
    Sync,
    Dashboard,
    Materials,
    PurchaseOrders,
    Projects,
    Sources,
    Forecasts,
    Accounting,
    ADMIN_ONLY,
    hasAccess,
};

export default ViewAccessService;
